/* src/app/components/auth-usage-charts/spending-plan/spending-plan.component.css */
.auth-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  padding: 2rem;
  place-items: center;
}
@media (max-width: 1024px) {
  .auth-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .auth-grid {
    grid-template-columns: 1fr;
  }
}
.auth-combined-grid {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;
}
.auth-chart-pair {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 2rem;
  flex-wrap: wrap;
}
@media (max-width: 900px) {
  .auth-chart-pair {
    flex-direction: column;
    align-items: center;
  }
}
.auth-row {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 5rem;
  padding: 2rem;
  flex-wrap: wrap;
}
.auth-info {
  display: block;
  text-align: center;
}
::ng-deep .popup-dialog.full-screen-dialog {
  padding: 0;
}
::ng-deep .popup-dialog.full-screen-dialog .content.xx-large {
  width: 100vw;
  max-width: 100vw;
  height: 100dvh;
  max-height: 100dvh;
  border-radius: 0;
}
:host ::ng-deep .ant-picker {
  width: 100%;
  height: 32px;
  padding: 0 11px;
}
:host ::ng-deep .ant-picker-input > input {
  height: 30px;
  padding: 0;
  font-size: 14px;
}
.help-icon-button {
  margin: 0;
  padding: 0 4px;
  border: none;
  background: transparent;
  color: #3d0072;
  font-size: 20px;
  line-height: 32px;
  vertical-align: middle;
  cursor: pointer;
}
.help-icon-button:hover {
  opacity: 0.75;
}
.help-icon-button:focus-visible {
  outline: 2px solid #3d0072;
  outline-offset: 2px;
  border-radius: 4px;
}
:host-context(body.dark-theme) .help-icon-button {
  color: inherit;
}
.applied-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 4px 0 16px;
  font-size: 13px;
}
.applied-filters-title {
  font-weight: 600;
}
.applied-filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border: 1px solid rgba(61, 0, 114, 0.2);
  border-radius: 12px;
  background: rgba(61, 0, 114, 0.06);
}
.applied-filter-label {
  font-weight: 600;
  opacity: 0.75;
}
.applied-filter-label::after {
  content: ":";
}
.provider-option {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
  white-space: normal;
}
.provider-option-name {
  font-weight: 500;
}
.provider-option-id {
  font-size: 12px;
  opacity: 0.65;
}
/*# sourceMappingURL=spending-plan.component-KEZMWYNB.css.map */
